import { Bell } from 'lucide-react';
import { EmptyState } from '@/components/EmptyState';

export function AlertsPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-foreground">Alerts</h1>
        <p className="text-sm text-foreground-muted">Important notifications and action items</p>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Bell className="h-10 w-10" />}
          title="No alerts"
          description="You'll be notified here when filament runs low, maintenance is due, or action is needed."
        />
      </div>
    </div>
  );
}
